import { ViewConfigTypeEnum } from '@salescore/client-api'
import { Alert } from 'antd'
import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

/**
 * VISUALIZE ライセンスがないユーザーに、閲覧できないことを表示する
 * @param viewType 開こうとした view の種別
 */
export const VisualizeUserPlanNotFound = ({ viewType }: { viewType: ViewConfigTypeEnum }): ReactElement => {
  const { t } = useTranslation()
  return (
    <div className="p-8">
      <Alert
        showIcon
        type="warning"
        message={
          <div>
            {t(`VISUALIZEライセンスがないため、{{viewTypeName}}を閲覧できません`, {
              viewTypeName: viewType === ViewConfigTypeEnum.Kpi ? t(`KPI`) : t(`ダッシュボード`),
            })}
            <br />
            {t(`組織の管理者に、VISUALIZEプランの契約とライセンス割り当てを依頼してください。`)}
          </div>
        }
      />
    </div>
  )
}
